export default __webpack_public_path__ + "static/media/col-icon.1b16c07a.svg";